import { useState } from "react"
import { useLocalWeather } from "@hooks/useLocalWeather"

type TWeatherWidgetProps = {
  account_id: string
}

export const WeatherWidget = ({ account_id }: TWeatherWidgetProps) => {
  const [showIcon, setShowIcon] = useState(true)
  const weather = useLocalWeather(account_id)

  return (
    <div className="tw:flex tw:items-center tw:justify-between tw:gap-3 tw:px-3 tw:text-black">
      {weather.isSuccess && (
        <>
          <span className="tw:font-semibold">{weather.temperature}</span>
          {showIcon && (
            <img
              src={weather.weatherIcon}
              alt={weather.weatherText}
              width={24}
              height={24}
              onError={() => setShowIcon(false)}
            />
          )}
          <span>{weather.weatherText}</span>
        </>
      )}
      <span className="tw:font-semibold">{weather.time}</span>
      <span>{weather.location}</span>
    </div>
  )
}
